"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarGroup = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Avatar = require("./Avatar");
var _reactstrap = require("reactstrap");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Avatar Group
 */
var AvatarGroup = exports.AvatarGroup = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(AvatarGroup, _Component);
  var _super = _createSuper(AvatarGroup);
  function AvatarGroup(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AvatarGroup);
    _this = _super.call(this, props);
    _this._toggle = _this._toggle.bind((0, _assertThisInitialized2["default"])(_this));
    _this._showPlusButton = showPlusButton.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      dropdownOpen: false
    };
    return _this;
  }
  (0, _createClass2["default"])(AvatarGroup, [{
    key: "_toggle",
    value: function _toggle() {
      this.setState({
        dropdownOpen: !this.state.dropdownOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var users = this.props.users;
      var max = this.props.max || 0;
      if (!users) return null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "collab-avatars"
      }, renderUsers(users, max), this._showPlusButton(users, max));
    }
  }]);
  return AvatarGroup;
}(_react.Component);
var renderUsers = function renderUsers(users, max) {
  return users.map(function (user, indx) {
    return indx < max ? /*#__PURE__*/_react["default"].createElement(_Avatar.Avatar, {
      key: "avatar-".concat(user._id),
      height: "28px",
      width: "28px",
      user: user
    }) : false;
  });
};
var showPlusButton = function showPlusButton(users, max) {
  var dropdownOpen = this.state.dropdownOpen;
  return users.length > max ? /*#__PURE__*/_react["default"].createElement(_reactstrap.Dropdown, {
    isOpen: dropdownOpen,
    toggle: this._toggle
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownToggle, {
    caret: true
  }, "+", users.length - max), /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownMenu, null, dropdownOpen && renderExtraUsers(users, max))) : null;
};
var renderExtraUsers = function renderExtraUsers(users, max) {
  return users.map(function (user, indx) {
    return indx >= max ? /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownItem, {
      className: "dd-privacy-mask",
      key: "".concat(user._id, "-menu-item-").concat(indx)
    }, /*#__PURE__*/_react["default"].createElement(_Avatar.Avatar, {
      key: "".concat(user._id, "-avatar-").concat(indx),
      height: "28px",
      width: "28px",
      user: user
    }), ' ', user.firstName, " ", user.lastName) : null;
  });
};
AvatarGroup.propTypes = {
  users: _propTypes["default"].array,
  max: _propTypes["default"].number
};